// extracted by mini-css-extract-plugin
module.exports = {"channelCard":"_2rUz-","description":"Jpi4a","button":"_2PQzo"};